import React from "react";
import "./MediaBackdrop.css";
import Media from "react-media";
import PreviewWrapper from "../PreviewMode/PreviewWrapper";
export class MediaBackdrop extends React.Component {
  state = {
    blurEffect: "blur"
  };
  componentDidMount() {
    setTimeout(() => this.setState({ blurEffect: "unblur" }), 3000);
  }
  generateYoutubeSource = () => {
    const { url } = this.props;
    if (!url.includes("https://www.youtube.com/watch?v=")) return "";
    let id = url.substring(url.indexOf("v=") + 2, url.length);
    return id;
  };
  setScale = ({ small, medium, large }) => {
    let translate = "translateX(-58%) translateY(-50%) ";
    if (small) translate += "scale(4)";
    else if (medium) translate += "scale(2.5)";
    else translate += "scale(1.5)";
    return translate;
  };
  setBackground = () => {
    const { main, device } = this.props;
    const bg = {};

    bg.backgroundSize = "cover";
    bg.backgroundPosition = main.backgroundPosition;
    bg.backgroundRepeat = "no-repeat";
    bg.background = main.background;
    bg.backgroundAttachment = "fixed";
    bg.height =
      this.props.editMode && (device === "desktop" || device === undefined) || (!this.props.editMode)
        ? "100vh"
        : "100%";
    bg.overflowY = this.props.editMode ? "auto" : "unset";
    return bg;
   
  };
  setHeight = () => {
    const { device, enabled } = this.props;
    if (this.props.editMode && (device === "desktop" || device === undefined) || (!this.props.editMode)) {
      return '100vh';
    } else if (this.props.editMode && device !== "desktop" && device !== undefined && enabled == true) {

      return '100%'
    } 
  }
  render() {
    const { url, children, enabled, device, main } = this.props;
    const { blurEffect } = this.state;
    return (
      <div className="marquee">
        <PreviewWrapper device={device}>
          {enabled === true && url !== "unset" && url !== "" ? (
            <div className={`youtube-background ${""}`}>
              <Media
                queries={{
                  small: "(max-width: 599px)",
                  medium: "(min-width: 600px) and (max-width: 1199px)",
                  large: "(min-width: 1200px)"
                }}
              >
                {matches => (
                  <iframe
                    style={{
                      transform: this.setScale(matches) /* , width, height */
                    }}
                    id="ytbg"
                    data-youtube={`https://www.youtube.com/watch?v=${this.generateYoutubeSource()}`}
                    frameBorder="0"
                    allowFullScreen="1"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    title="YouTube video player"
                    src={`https://www.youtube.com/embed/${this.generateYoutubeSource()}?controls=0&amp;autoplay=1&amp;mute=1&amp;origin=https%3A%2F%2Fwww.jqueryscript.net&amp;loop=1&amp;rel=0&amp;ecver=2&amp;showinfo=0&amp;modestbranding=1&amp;enablejsapi=1&amp;widgetid=1`}
                  ></iframe>
                )}
              </Media>
            </div>
          ) : null}
          <div
            className="content"
            style={
              enabled !== true
                ? this.setBackground()
                : {
                  overflowY: this.props.editMode || enabled === true ? "auto" : "unset",
                  height: this.setHeight()
                }
            }
          >
            <div className="inner">{children}</div>
          </div>
        </PreviewWrapper>
      </div>
    );
  }
}
